import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=60aef0c1&"
import script from "./UiInput.vue?vue&type=script&lang=js&"
export * from "./UiInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports